//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v10.9.0.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming



export interface Address {
    line1: string;
    line2: string | null;
    line3: string | null;
    line4: string | null;
    locality: string | null;
    region: string | null;
    postcode: string;
    country: string | null;
    latitude: string | null;
    longitude: string | null;
    source: string | null;
}

export interface BinaryDataWrapper {
    data: string | null;
}

export interface DealerQuotePriceAdjustment {
    title: string | null;
    description: string | null;
    comment: string | null;
    adjustmentMethod: DealerQuotePriceAdjustmentMethod;
    adjustmentValue: number;
    isTaxable: boolean;
}

export enum DealerQuotePriceAdjustmentMethod {
    PriceAdjustment = 0,
    SubtotalAdjustment = 1,
    TotalAdjustment = 2,
}

export interface ExternalProviderDefinition {
    referenceId: string;
    service: string;
    data: string;
}

export interface InitialPriceDefinition {
    singleUnitCost: number;
    supplierPriceAdjustment: number;
    supplierGrossSingleUnitCost: number;
    supplierNettSingleUnitCost: number;
    sourceData: { [key: string]: number; };
}

export interface InputCreateQuote {
    quoteOwnerId: string;
    supplierId: string;
    id: string | null;
    title: string | null;
    validUntilDate: string | null;
    termsAndConditions: string;
    quoteType: QuoteType;
    shippingTitle: string | null;
    shippingDescription: string | null;
    serviceProvider: string;
    serviceProviderData: string | null;
    taxPercentage: number;
    excludeShippingLineItem: boolean | null;
    allowNonTaxableItems: boolean | null;
}

export interface InputCreateQuoteItem {
    quoteId: string;
    quoteItemId: string;
    title: string | null;
    description: string | null;
    quantity: number | null;
    comment: string | null;
    virtualThumbnailPath: string;
    externalProvider: ExternalProviderDefinition | null;
    buyInData: BinaryDataWrapper | null;
    price: InitialPriceDefinition | null;
    quoteItemContentType: number;
    isRestrictedToPowerUser: boolean | null;
    isTaxableItem: boolean | null;
}

export interface InputDeleteQuote {
    quoteId: string;
}

export interface InputDeleteQuoteItem {
    quoteItemId: string;
}

export interface InputDuplicateQuote {
    quoteId: string;
    validUntilDate: string;
    asAlternate: boolean;
    alternativeType: QuoteAlternativeType;
    numberSeed: string | null;
    title: string | null;
    quoteState: QuoteState | null;
    quoteCustomerId: string | null;
    excludedQuoteItems: string[] | null;
}

export interface InputDuplicateQuoteItem {
    quoteItemId: string;
}

export interface InputLapseQuotes {
    tenantId: number | null;
    cutOffDate: string;
}

export interface InputQuoteState {
    quoteId: string;
    state: QuoteState;
    stateChangeReason: InputUpdateQuoteStateChangeReason | null;
}

export interface InputSetQuoteAssignedToUser {
    userId: string;
    quoteIds: string[];
}

export interface InputUpdateEtoItems {
    quoteItemIds: string[];
    title: string;
    reference: string;
    singleUnitCost: number;
    thumbnail: string;
}

export interface InputUpdateEtoItemsV2 {
    quoteItemIds: string[];
    title: string;
    reference: string;
    price: QuoteItemPrice;
    thumbnail: string;
}

export interface InputUpdateQuote {
    siblingQuoteState: InputQuoteState[] | null;
    quote: Quote | null;
    quotePrice: QuotePrice | null;
    numberSeed: string | null;
    stateChangeReason: InputUpdateQuoteStateChangeReason | null;
    quotePresentation: QuotePresentation | null;
}

export interface InputUpdateQuoteItem {
    quoteItemId: string;
    quoteItem: QuoteItem | null;
    quoteItemProviderData: QuoteItemProviderData | null;
    quoteItemBuyInData: BinaryDataWrapper | null;
    quoteItemPrice: QuoteItemPrice | null;
}

export interface InputUpdateQuoteItems {
    items: UpdateQuoteItem[];
}

export interface InputUpdateQuotePrice {
    quotePrice: QuotePrice;
    dealerQuotePriceAdjustment: DealerQuotePriceAdjustment;
    quoteItems: QuoteItem[] | null;
    quoteItemPrices: QuoteItemPrice[] | null;
    commitChanges: boolean;
}

export interface InputUpdateQuoteSetState {
    quoteState: InputQuoteState[];
}

export interface InputUpdateQuoteStateChangeReason {
    stateChangeReason: QuoteStateChangeReason;
    comment: string;
}

export interface Quote {
    dateCreated: string;
    id: string;
    recordVersion: string;
    quoteSetId: string;
    quoteOwnerId: string;
    quoteCustomerId: string;
    quoteNumber: number;
    quoteSuffix: string;
    alternativeType: QuoteAlternativeType;
    title: string;
    state: QuoteState;
    quoteType: QuoteType;
    budget: number | null;
    description: string;
    termsAndConditions: string | null;
    validUntilDate: string | null;
    installationDate: string | null;
    creationUserId: string;
    lastModifiedUserId: string;
    lastModifiedDate: string | null;
    supplierId: string;
    supplierApproved: boolean;
    supplierAuthorizedToIssueOrderOnQuoteApproval: boolean;
    serviceProvider: string;
    serviceProviderData: string | null;
    shippingAddress: Address | null;
    shippingNotes: string | null;
    customQuoteNumber: string | null;
    assignedToUserId: string;
    allowNonTaxableItems: boolean | null;
    isShippingTaxable: boolean;
}

export enum QuoteAlternativeType {
    Standard = 0,
    SupplierReview = 1,
}

export interface QuoteDTO {
    id: string;
    quoteSetId: string;
    branchId: string;
    title: string;
    state: number;
    quoteType: number;
    quoteNumber: number;
    quoteSuffix: string;
    dateCreated: string;
    lastModifiedDate: string;
    lastModifiedUserId: string;
    creationUserId: string;
    validUntilDate: string | null;
    installationDate: string | null;
    recordVersion: string;
    calculatedGrossTotal: number;
    assignedToUserId: string;
}

export interface QuoteHistoryState {
    state: QuoteState;
    numberOfDaysHistory: number | null;
}

export interface QuoteItem {
    dateCreated: string;
    id: string;
    recordVersion: string;
    quoteId: string;
    commonId: string;
    readonly itemType: QuoteItemType;
    title: string;
    description: string;
    quantity: number;
    comment: string | null;
    providerReferenceId: string;
    serviceProvider: string;
    quoteItemContentType: number;
    virtualThumbnailPath: string;
    isRestrictedToPowerUser: boolean;
    lastModifiedDate: string | null;
    lastModifiedUserId: string | null;
}

export interface QuoteItemBuyInData {
    dateCreated: string;
    id: string;
    recordVersion: string;
    buyInData: string | null;
}

export interface QuoteItemPrice {
    dateCreated: string;
    id: string;
    recordVersion: string;
    singleUnitCost: number;
    quantityCost: number;
    supplierGrossSingleUnitCost: number;
    supplierGrossQuantityCost: number;
    supplierNettSingleUnitCost: number;
    supplierNettQuantityCost: number;
    supplierPriceAdjustment: number;
    percentMarginOrMarkup: number | null;
    priceAdjustment: number;
    calculatedNetSellingPrice: number;
    calculatedGrossSellingPrice: number;
    sourceData: { [key: string]: number; };
    requiresRepricing: boolean;
    isTaxableItem: boolean;
}

export interface QuoteItemProviderData {
    dateCreated: string;
    id: string;
    recordVersion: string;
    providerData: string | null;
    lastModifiedDate: string | null;
    lastModifiedUserId: string | null;
}

export enum QuoteItemRowAction {
    Insert = 0,
    Update = 1,
    Delete = 2,
}

export enum QuoteItemType {
    None = 0,
    Basic = 1,
    Provider = 2,
}

export interface QuotePresentation {
    dateCreated: string;
    id: string;
    recordVersion: string;
    itemDisplayOrder: string[];
}

export interface QuotePrice {
    dateCreated: string;
    id: string;
    recordVersion: string;
    percentMarginOrMarkup: number;
    calculation: QuotePriceCalculation;
    taxPercentage: number;
    priceAdjustment: number;
    calculatedLineItemTotal: number;
    calculatedNetTotal: number;
    calculatedTaxAmount: number;
    calculatedGrossTotal: number;
}

export enum QuotePriceCalculation {
    Margin = 1,
    Markup = 2,
}

export interface QuoteSetSibling {
    quoteId: string;
    quoteSetId: string;
    state: QuoteState;
    alternativeType: QuoteAlternativeType;
    quoteNumber: number;
    quoteSuffix: string;
    supplierApproved: boolean;
    recordVersion: string;
}

export enum QuoteState {
    None = 0,
    Draft = 1,
    Active = 2,
    Issued = 4,
    Accepted = 8,
    Rejected = 16,
    Lapsed = 32,
    Cancelled = 64,
    IssuePending = 128,
    SupplierReviewPending = 256,
    SupplierReviewed = 512,
    Approved = 1024,
    Accepted_RefusedBySupplier = 2048,
    Accepted_AssignedToReviewer = 4096,
}

export interface QuoteStateAudit {
    dateCreated: string;
    id: string;
    recordVersion: string;
    quoteId: string;
    state: QuoteState;
    dateModified: string;
    systemUserId: string;
    stateChangeReasonId: string | null;
    comment: string | null;
}

export interface QuoteStateChangeReason {
    dateCreated: string;
    id: string;
    recordVersion: string;
    quoteStateReasonOwnerId: string;
    category: QuoteState;
    reason: string;
}

export interface QuoteStateChangeReasonPresentation {
    dateCreated: string;
    id: string;
    recordVersion: string;
    quoteStateReasonOwnerId: string;
    category: QuoteState;
    itemDisplayOrder: string[];
}

export enum QuoteType {
    None = 0,
    Estimate = 1,
    Quote = 2,
    Display = 4,
    Warranty = 8,
}

export interface RequestGetGuids {
    count: number;
}

export interface RequestGetIssuedQuoteRevenue {
    startDate: string;
    endDate: string;
    branchId: string;
    userId: string;
}

export interface RequestGetNewQuotesForSupplier {
    quoteOwnerFilter: string[];
    supplierId: string;
    deploymentId: number;
    fromRecordVersion: string;
}

export interface RequestGetQuote {
    quoteId: string;
}

export interface RequestGetQuoteItem {
    quoteItemId: number;
}

export interface RequestGetQuoteItemPrice {
    quoteItemId: number;
}

export interface RequestGetQuoteItemsSummary {
    quoteId: string;
}

export interface RequestGetQuoteItemsSummaryById {
    quoteItemId: string[];
}

export interface RequestGetQuotePrice {
    quoteId: string;
}

export interface RequestGetQuoteSetSummary {
    quoteOwnerId: string;
    quoteSetId: string;
}

export interface RequestGetQuoteStateAudit {
    quoteId: string;
    state: QuoteState | null;
}

export interface RequestGetQuoteStateChangeReasonsByOwnerIds {
    quoteStateReasonsOwnerIds: string[];
}

export interface RequestGetQuoteSummary {
    quoteOwnerId: string;
    statesToLoad: QuoteState;
    numberOfDaysHistory: number | null;
    title: string | null;
    description: string | null;
    pageSize: number;
    pageIndex: number;
    sortField: string | null;
    sortAsc: boolean;
    assignedToUserId: string | null;
}

export interface RequestGetQuoteSummaryListByIds {
    quoteIds: string[];
}

export interface RequestGetQuoteTotalsByState {
    quoteOwnerId: string;
    options: QuoteHistoryState[];
}

export interface RequestGetQuoteUserIdsByOwnerId {
    ownerId: string;
}

export interface RequestGetQuoteUserIdsByOwnerIds {
    ownerIds: string[];
}

export interface ResultCreateQuote {
    quote: Quote;
    quotePrice: QuotePrice;
    quotePresentation: QuotePresentation;
}

export interface ResultCreateQuoteItem {
    quoteItem: QuoteItem;
    quoteItemProviderData: QuoteItemProviderData | null;
    quoteItemBuyInData: string | null;
    quoteItemPrice: QuoteItemPrice;
    resultFullQuotePrice: ResultFullQuotePrice;
    quote: Quote;
    quotePresentation: QuotePresentation;
}

export interface ResultCreateQuoteItemServiceResponse {
    responseType: ServiceResponseType;
    readonly responseTypeCaption: string;
    responseError: ServiceResponseError | null;
    result: ResultCreateQuoteItem | null;
}

export interface ResultCreateQuoteServiceResponse {
    responseType: ServiceResponseType;
    readonly responseTypeCaption: string;
    responseError: ServiceResponseError | null;
    result: ResultCreateQuote | null;
}

export interface ResultDeleteQuote {
}

export interface ResultDeleteQuoteItem {
    resultFullQuotePrice: ResultFullQuotePrice;
    quotePresentation: QuotePresentation;
    quote: Quote;
}

export interface ResultDeleteQuoteItemServiceResponse {
    responseType: ServiceResponseType;
    readonly responseTypeCaption: string;
    responseError: ServiceResponseError | null;
    result: ResultDeleteQuoteItem | null;
}

export interface ResultDeleteQuoteServiceResponse {
    responseType: ServiceResponseType;
    readonly responseTypeCaption: string;
    responseError: ServiceResponseError | null;
    result: ResultDeleteQuote | null;
}

export interface ResultDuplicateQuote {
    siblings: QuoteSetSibling[];
    source: Quote;
    quote: Quote;
    quotePrice: QuotePrice;
    quotePresentation: QuotePresentation;
}

export interface ResultDuplicateQuoteItem {
    quoteItem: QuoteItem;
    quoteItemPrice: QuoteItemPrice;
    quoteItemProviderData: QuoteItemProviderData | null;
    quoteItemBuyInData: QuoteItemBuyInData | null;
    quotePresentation: QuotePresentation;
    resultFullQuotePrice: ResultFullQuotePrice;
    quote: Quote;
}

export interface ResultDuplicateQuoteItemServiceResponse {
    responseType: ServiceResponseType;
    readonly responseTypeCaption: string;
    responseError: ServiceResponseError | null;
    result: ResultDuplicateQuoteItem | null;
}

export interface ResultDuplicateQuoteServiceResponse {
    responseType: ServiceResponseType;
    readonly responseTypeCaption: string;
    responseError: ServiceResponseError | null;
    result: ResultDuplicateQuote | null;
}

export interface ResultFullQuotePrice {
    quotePrice: QuotePrice;
    itemPrices: QuoteItemPrice[];
    itemBuyIns: QuoteItemBuyInData[];
}

export interface ResultGetGuids {
    guids: string[];
}

export interface ResultGetGuidsServiceResponse {
    responseType: ServiceResponseType;
    readonly responseTypeCaption: string;
    responseError: ServiceResponseError | null;
    result: ResultGetGuids | null;
}

export interface ResultGetIssuedQuoteRevenue {
    revenueSummary: ViewDailyRevenue[];
    startDate: string;
    endDate: string;
}

export interface ResultGetIssuedQuoteRevenueServiceResponse {
    responseType: ServiceResponseType;
    readonly responseTypeCaption: string;
    responseError: ServiceResponseError | null;
    result: ResultGetIssuedQuoteRevenue | null;
}

export interface ResultGetNewQuotesForSupplier {
    quotes: QuoteDTO[];
}

export interface ResultGetNewQuotesForSupplierServiceResponse {
    responseType: ServiceResponseType;
    readonly responseTypeCaption: string;
    responseError: ServiceResponseError | null;
    result: ResultGetNewQuotesForSupplier | null;
}

export interface ResultGetQuote {
    quote: Quote;
    quotePrice: QuotePrice;
    quotePresentation: QuotePresentation;
    siblings: QuoteSetSibling[];
}

export interface ResultGetQuoteItem {
    quoteItem: QuoteItem;
}

export interface ResultGetQuoteItemPrice {
    quoteItemPrice: QuoteItemPrice;
}

export interface ResultGetQuoteItemPriceServiceResponse {
    responseType: ServiceResponseType;
    readonly responseTypeCaption: string;
    responseError: ServiceResponseError | null;
    result: ResultGetQuoteItemPrice | null;
}

export interface ResultGetQuoteItemServiceResponse {
    responseType: ServiceResponseType;
    readonly responseTypeCaption: string;
    responseError: ServiceResponseError | null;
    result: ResultGetQuoteItem | null;
}

export interface ResultGetQuoteItemsSummary {
    items: QuoteItem[];
    data: QuoteItemProviderData[];
    prices: QuoteItemPrice[];
    quoteItemBuyInData: QuoteItemBuyInData[];
}

export interface ResultGetQuoteItemsSummaryById {
    items: QuoteItem[];
    data: QuoteItemProviderData[];
    prices: QuoteItemPrice[];
    quoteItemBuyInData: QuoteItemBuyInData[];
}

export interface ResultGetQuoteItemsSummaryByIdServiceResponse {
    responseType: ServiceResponseType;
    readonly responseTypeCaption: string;
    responseError: ServiceResponseError | null;
    result: ResultGetQuoteItemsSummaryById | null;
}

export interface ResultGetQuoteItemsSummaryServiceResponse {
    responseType: ServiceResponseType;
    readonly responseTypeCaption: string;
    responseError: ServiceResponseError | null;
    result: ResultGetQuoteItemsSummary | null;
}

export interface ResultGetQuotePrice {
    quotePrice: QuotePrice;
}

export interface ResultGetQuotePriceServiceResponse {
    responseType: ServiceResponseType;
    readonly responseTypeCaption: string;
    responseError: ServiceResponseError | null;
    result: ResultGetQuotePrice | null;
}

export interface ResultGetQuoteServiceResponse {
    responseType: ServiceResponseType;
    readonly responseTypeCaption: string;
    responseError: ServiceResponseError | null;
    result: ResultGetQuote | null;
}

export interface ResultGetQuoteSetSummary {
    quoteSummary: ViewQuoteSummary[];
}

export interface ResultGetQuoteSetSummaryServiceResponse {
    responseType: ServiceResponseType;
    readonly responseTypeCaption: string;
    responseError: ServiceResponseError | null;
    result: ResultGetQuoteSetSummary | null;
}

export interface ResultGetQuoteStateAudit {
    quoteStateAudit: QuoteStateAudit[];
}

export interface ResultGetQuoteStateAuditServiceResponse {
    responseType: ServiceResponseType;
    readonly responseTypeCaption: string;
    responseError: ServiceResponseError | null;
    result: ResultGetQuoteStateAudit | null;
}

export interface ResultGetQuoteStateChangeReasonsByOwnerIds {
    quoteReasons: ResultQuoteStateChangeReasonsForOwnerId[];
}

export interface ResultGetQuoteStateChangeReasonsByOwnerIdsServiceResponse {
    responseType: ServiceResponseType;
    readonly responseTypeCaption: string;
    responseError: ServiceResponseError | null;
    result: ResultGetQuoteStateChangeReasonsByOwnerIds | null;
}

export interface ResultGetQuoteSummary {
    quoteSummary: ViewQuoteSummaryResultPaginated;
}

export interface ResultGetQuoteSummaryListByIds {
    quoteSummaries: ViewQuoteSummary[];
}

export interface ResultGetQuoteSummaryListByIdsServiceResponse {
    responseType: ServiceResponseType;
    readonly responseTypeCaption: string;
    responseError: ServiceResponseError | null;
    result: ResultGetQuoteSummaryListByIds | null;
}

export interface ResultGetQuoteSummaryServiceResponse {
    responseType: ServiceResponseType;
    readonly responseTypeCaption: string;
    responseError: ServiceResponseError | null;
    result: ResultGetQuoteSummary | null;
}

export interface ResultGetQuoteTotalsByState {
    totals: ViewQuoteTotalByState[];
}

export interface ResultGetQuoteTotalsByStateServiceResponse {
    responseType: ServiceResponseType;
    readonly responseTypeCaption: string;
    responseError: ServiceResponseError | null;
    result: ResultGetQuoteTotalsByState | null;
}

export interface ResultGetQuoteUserIdsByOwnerId {
    userIds: string[];
}

export interface ResultGetQuoteUserIdsByOwnerIdServiceResponse {
    responseType: ServiceResponseType;
    readonly responseTypeCaption: string;
    responseError: ServiceResponseError | null;
    result: ResultGetQuoteUserIdsByOwnerId | null;
}

export interface ResultGetQuoteUserIdsByOwnerIdV1 {
    ownerId: string;
    userIds: string[];
}

export interface ResultGetQuoteUserIdsByOwnerIds {
    values: ResultGetQuoteUserIdsByOwnerIdV1[];
}

export interface ResultGetQuoteUserIdsByOwnerIdsServiceResponse {
    responseType: ServiceResponseType;
    readonly responseTypeCaption: string;
    responseError: ServiceResponseError | null;
    result: ResultGetQuoteUserIdsByOwnerIds | null;
}

export interface ResultLapseQuotes {
    lapsedQuotes: string[];
}

export interface ResultLapseQuotesServiceResponse {
    responseType: ServiceResponseType;
    readonly responseTypeCaption: string;
    responseError: ServiceResponseError | null;
    result: ResultLapseQuotes | null;
}

export interface ResultQuoteItem {
    quoteItem: QuoteItem | null;
    quoteItemProviderData: QuoteItemProviderData | null;
    quoteItemBuyInData: string | null;
    quoteItemPrice: QuoteItemPrice | null;
}

export interface ResultQuoteStateChangeReasonsForOwnerId {
    quoteStateReasonOwnerId: string;
    quoteReasons: ResultQuoteStateChangeReasonsForState[];
}

export interface ResultQuoteStateChangeReasonsForState {
    category: QuoteState;
    presentation: QuoteStateChangeReasonPresentation;
    stateChangeReasons: QuoteStateChangeReason[];
}

export interface ResultSetQuoteAssignedToUser {
}

export interface ResultSetQuoteAssignedToUserServiceResponse {
    responseType: ServiceResponseType;
    readonly responseTypeCaption: string;
    responseError: ServiceResponseError | null;
    result: ResultSetQuoteAssignedToUser | null;
}

export interface ResultUpdateEtoItems {
    quoteItems: ResultQuoteItem[];
}

export interface ResultUpdateEtoItemsServiceResponse {
    responseType: ServiceResponseType;
    readonly responseTypeCaption: string;
    responseError: ServiceResponseError | null;
    result: ResultUpdateEtoItems | null;
}

export interface ResultUpdateQuote {
    quote: Quote | null;
    resultFullQuotePrice: ResultFullQuotePrice | null;
    siblings: QuoteSetSibling[] | null;
    quotePresentation: QuotePresentation | null;
}

export interface ResultUpdateQuoteItem {
    quoteItem: QuoteItem | null;
    quoteItemProviderData: QuoteItemProviderData | null;
    quoteItemBuyInData: string | null;
    quoteItemPrice: QuoteItemPrice | null;
    resultFullQuotePrice: ResultFullQuotePrice | null;
    quote: Quote;
}

export interface ResultUpdateQuoteItemServiceResponse {
    responseType: ServiceResponseType;
    readonly responseTypeCaption: string;
    responseError: ServiceResponseError | null;
    result: ResultUpdateQuoteItem | null;
}

export interface ResultUpdateQuoteItems {
    resultFullQuotePrice: ResultFullQuotePrice | null;
    quote: Quote;
    quotePresentation: QuotePresentation | null;
    items: ResultQuoteItem[];
}

export interface ResultUpdateQuoteItemsServiceResponse {
    responseType: ServiceResponseType;
    readonly responseTypeCaption: string;
    responseError: ServiceResponseError | null;
    result: ResultUpdateQuoteItems | null;
}

export interface ResultUpdateQuotePrice {
    quote: Quote | null;
    resultFullQuotePrice: ResultFullQuotePrice | null;
    siblings: QuoteSetSibling[] | null;
    quotePresentation: QuotePresentation | null;
    updatedQuoteItems: QuoteItem[];
}

export interface ResultUpdateQuotePriceServiceResponse {
    responseType: ServiceResponseType;
    readonly responseTypeCaption: string;
    responseError: ServiceResponseError | null;
    result: ResultUpdateQuotePrice | null;
}

export interface ResultUpdateQuoteServiceResponse {
    responseType: ServiceResponseType;
    readonly responseTypeCaption: string;
    responseError: ServiceResponseError | null;
    result: ResultUpdateQuote | null;
}

export interface ResultUpdateQuoteSetState {
    items: QuoteSetSibling[];
}

export interface ResultUpdateQuoteSetStateServiceResponse {
    responseType: ServiceResponseType;
    readonly responseTypeCaption: string;
    responseError: ServiceResponseError | null;
    result: ResultUpdateQuoteSetState | null;
}

export interface ServiceResponseError {
    message: string;
    stackTrace: string | null;
}

export enum ServiceResponseType {
    None = 0,
    Ok = 1,
    NotFound = 2,
    UnAuthenticated = 4,
    UnAuthorized = 8,
    Error = 16,
    TransientDbError = 32,
    ValidationFailure = 64,
    ModifyNotFound = 128,
}

export interface UpdateQuoteItem {
    action: QuoteItemRowAction;
    input: InputUpdateQuoteItem;
}

export interface ViewDailyRevenue {
    count: number;
    date: string;
    dailyRevenue: number;
}

export interface ViewQuoteSummary {
    supplierId: string;
    id: string;
    title: string;
    dateCreated: string;
    creationUserId: string;
    lastModifiedDate: string | null;
    lastModifiedUserId: string;
    assignedToUserId: string;
    description: string;
    quoteOwnerId: string;
    quoteCustomerId: string;
    calculation: QuotePriceCalculation;
    percentMarginOrMarkup: number;
    calculatedGrossTotal: number;
    calculatedNetTotal: number;
    calculatedTaxAmount: number;
    quoteNumber: number;
    quoteSuffix: string;
    state: QuoteState;
    quoteType: QuoteType;
    recordVersion: string;
}

export interface ViewQuoteSummaryResultPaginated {
    count: number;
    pageCount: number;
    pageSize: number;
    pageIndex: number;
    results: ViewQuoteSummary[];
}

export interface ViewQuoteTotalByState {
    quoteOwnerId: string;
    total: number;
    userId: string;
    quoteState: QuoteState;
    quoteCount: number;
}